import React, { useState } from 'react';
import {
  ThemeProvider,
  CssBaseline,
  Box,
} from '@mui/material';
import { lightTheme, darkTheme } from './themes/theme';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Contact from './components/Contact';
import Footer from './components/Footer';
import InstallPWA from './components/InstallPWA';

const App: React.FC = () => {
  const [darkMode, setDarkMode] = useState(false);
  const theme = darkMode ? darkTheme : lightTheme;

  const handleToggleTheme = () => {
    setDarkMode(!darkMode);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          bgcolor: 'background.default',
          color: 'text.primary',
        }}
      >
        <Header darkMode={darkMode} onToggleDarkMode={handleToggleTheme} />
        <InstallPWA />
        
        <main>
          <Hero />
          <Box sx={{ mt: { xs: 0, md: 0 } }}>
            <Features />
          </Box>
          <Box sx={{ mt: { xs: 0, md: 0 } }}>
            <HowItWorks />
          </Box>
          <Box sx={{ mt: { xs: 0, md: 0 } }}>
            <Contact />
          </Box>
          <Footer />
        </main>
      </Box>
    </ThemeProvider>
  );
};

export default App; 